import { z } from 'zod';

import { HoldingEventType } from '@dealstack/shared/lib/generated';

export const CreateHoldingsEventShape = z.object({
	holderId: z.string().nonempty({ message: 'holdingsId is required' }),
	securityId: z.string().nonempty({ message: 'securityId is required' }),
	date: z
		.string({
			required_error: 'The date is required',
			invalid_type_error: 'The date is required',
		})
		.datetime({ message: 'The date is required' }),
	type: z.nativeEnum(HoldingEventType, { invalid_type_error: 'Required' }),
	note: z.string().optional(),
	pledgeToPersonId: z.string().nullish(),
	pledgeToString: z.string().optional(),
	pledgeFromHolderId: z.string().nullish(),
	pledgeFromSecurityId: z.string().nullish(),
	pledgeFromString: z.string().optional(),
	assignedToPersonId: z.string().nullish(),
	assignedToString: z.string().optional(),
	description: z.string().optional(),
	documentUrl: z.string().optional(),
	documentName: z.string().optional(),
});

export type CreateHoldingsEventDto = z.infer<typeof CreateHoldingsEventShape>;

export const UpdateHoldingsEventShape = z.object({
	id: z.string(),
	date: z.string().optional(),
	note: z.string().optional(),
	type: z.nativeEnum(HoldingEventType).optional(),
	pledgeToPersonId: z.string().nullish(),
	pledgeToString: z.string().optional(),
	pledgeFromHolderId: z.string().nullish(),
	pledgeFromSecurityId: z.string().nullish(),
	pledgeFromString: z.string().optional(),
	assignedToPersonId: z.string().nullish(),
	assignedToString: z.string().optional(),
	description: z.string().optional(),
	documentUrl: z.string().optional(),
	documentName: z.string().optional(),
	fileId: z.string().optional(),
});

export const BulkCreateHoldingsEventFormShape = z.object({
	date: z
		.string({
			required_error: 'The date is required',
			invalid_type_error: 'The date is required',
		})
		.datetime({ message: 'The date is required' }),
	type: z.nativeEnum(HoldingEventType, { invalid_type_error: 'Required' }),
	note: z.string().optional(),
	pledgeToPersonId: z.string().nullish(),
	pledgeToString: z.string().optional(),
	pledgeFromHolderId: z.string().nullish(),
	pledgeFromSecurityId: z.string().nullish(),
	pledgeFromString: z.string().optional(),
	assignedToPersonId: z.string().nullish(),
	assignedToString: z.string().optional(),
	documentUrl: z.string().optional(),
	documentName: z.string().optional(),
	fileId: z.string().optional(),
});

export type BulkCreateHoldingsEventFormDto = z.infer<typeof BulkCreateHoldingsEventFormShape>;
